import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { CALENDLY_LINK } from '../../../utils/constants';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.1%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            {/* Credential Badge */}
            <div className="inline-flex items-center bg-sky-500/20 border border-sky-400/30 rounded-full px-4 py-2">
              <Icon name="Scale" size={16} className="text-sky-400 mr-2" />
              <span className="text-sm font-medium text-sky-300">Court-Nominable Expert Witness</span>
            </div>

            <div className="space-y-6">
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight">
                <span className="text-white">Expert Valuation</span>
                <br />
                <span className="text-sky-400">Testimony</span>
              </h1>

              <p className="text-xl lg:text-2xl text-slate-300 leading-relaxed">
                Defensible expert opinions and credible courtroom testimony for complex valuation disputes across jurisdictions.
              </p>

              <div className="grid sm:grid-cols-2 gap-6 pt-4">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0 w-12 h-12 bg-sky-500/20 rounded-lg flex items-center justify-center">
                    <Icon name="Award" size={20} className="text-sky-400" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white">CVA</div>
                    <div className="text-sm text-slate-400">Certified Valuation Analyst</div>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0 w-12 h-12 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                    <Icon name="CheckCircle" size={20} className="text-emerald-400" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white">50+</div>
                    <div className="text-sm text-slate-400">Court Testimonies</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                variant="default"
                size="lg"
                className="bg-sky-500 hover:bg-sky-600 text-white"
                iconName="Calendar"
                iconPosition="left"
                asChild
              >
                <Link to="/book-consultation">
                  Schedule Expert Consultation
                </Link>
              </Button>

              <Button
                variant="outline"
                size="lg"
                className="border-slate-600 text-slate-300 hover:bg-slate-800"
                iconName="Download"
                iconPosition="left"
              >
                Download CV & Credentials
              </Button>
            </div>
          </div>

          {/* Visual Element */}
          {/* <div className="relative">
            <div className="relative bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8">
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-white">Expert Witness Qualifications</h3>
                  <Icon name="Scale" size={24} className="text-sky-400" />
                </div>

                <div className="space-y-4">
                  <div className="flex items-center justify-between py-3 border-b border-slate-700">
                    <span className="text-slate-300">Court Appointments</span>
                    <span className="text-white font-semibold">15+ Jurisdictions</span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-slate-700">
                    <span className="text-slate-300">Expert Reports Filed</span>
                    <span className="text-white font-semibold">200+</span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-slate-700">
                    <span className="text-slate-300">Deposition Experience</span>
                    <span className="text-white font-semibold">100+ Hours</span>
                  </div>
                  <div className="flex items-center justify-between py-3">
                    <span className="text-slate-300">Success Rate</span>
                    <span className="text-emerald-400 font-semibold">95%</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -top-4 -right-4 w-20 h-20 bg-sky-500/20 rounded-full blur-xl"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-emerald-500/20 rounded-full blur-xl"></div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;